export enum PageType {
  BecomeReferrer = 'become-referrer',
  Referrer = 'referrer',
  OpenMember = 'open-member',
  OpenMemberSuccess = 'open-member-success',
  ContentRenderer = 'content-renderer',
  ShareTransition = 'share-transition',
  OpenReferrerSuccess = 'open-referrer-success',
  BindingRelationshipDes = 'binding-relationship-des',
  ShareNoticeDetail = 'share-notice-detail',
  Tungea = 'tungea',
  TungeaWithCode = 'tungea-with-code',
  ApplyDataLink = 'apply-data-link',
  DeliverDataLink = 'deliver-data-link',
  TungeaNoticeDetail = 'tungea-notice-detail',
  /** 短信短链：域名后直接跟短码，如 /Wh7hpfm */
  TungeaNoticeDetailShort = 'tungea-notice-detail-short',
  MarketingClaim = 'marketing-claim',
  /** 报名工具历史通告迁移（公开页） */
  BaomingMigrate = 'baoming-migrate',
}

export enum OrderType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  INVITE_CODE = 'INVITE_CODE',
  DISTRIBUTOR = 'DISTRIBUTOR',
  OTHER = 'OTHER',
}
export const OrderTypeText: Record<OrderType, string> = {
  [OrderType.SUBSCRIPTION]: '订阅订单',
  [OrderType.INVITE_CODE]: '购买推荐码',
  [OrderType.DISTRIBUTOR]: '推荐官套餐',
  [OrderType.OTHER]: '其他订单',
};

export enum OrderStatus {
  UNPAID = 'UNPAID', // 待支付
  FAIL = 'FAIL', // 支付失败
  PAID = 'PAID', // 已支付
  COMPLETED = 'COMPLETED', // 已完成
  CANCELLED = 'CANCELLED', // 已取消
  REFUNDED = 'REFUNDED', // 已退款
}

// 可选：映射中文描述
export const OrderStatusText: Record<OrderStatus, string> = {
  [OrderStatus.UNPAID]: '待支付',
  [OrderStatus.FAIL]: '支付失败',
  [OrderStatus.PAID]: '已支付',
  [OrderStatus.COMPLETED]: '已完成',
  [OrderStatus.CANCELLED]: '已取消',
  [OrderStatus.REFUNDED]: '已退款',
};

export enum OrderPayType {
  WECHAT = 'WECHAT', // 微信支付
  ALIPAY = 'ALIPAY', // 支付宝
  BANK_CARD = 'BANK_CARD', // 银行卡
}

// 可选：映射中文描述
export const OrderPayTypeText: Record<OrderPayType, string> = {
  [OrderPayType.WECHAT]: '微信支付',
  [OrderPayType.ALIPAY]: '支付宝',
  [OrderPayType.BANK_CARD]: '银行卡',
};

// 配置类型
export enum ConfigType {
  // 会员开通成功后页面的企业微信二维码
  CUSTOMER_QR_CODE = 'customer.qr.code',
  // 进群同步通告微信二维码
  NOTICE_SYNC_GROUP_QR_CODE = 'notice.sync.group.qr.code',
  // 专属分发招募微信二维码
  DISTRIBUTION_EXCLUSIVE_RECRUIT = 'distribution.exclusive.recruit',
  // 探鲸公众号二维码
  GZH_TUNGEA_QR_CODE = 'gzh.tungea.qr.code',
  // 探鲸推荐官开通咨询二维码
  DISTRIBUTOR_CONSULT = 'distributor.consult',
  // 探鲸推荐官开通成功二维码
  DISTRIBUTOR_OPEN_SUCCESS = 'distributor.open.success',
  // 探鲸团长推荐官开通成功二维码
  DISTRIBUTOR_COMMANDER_OPEN_SUCCESS = 'distributor.commander.open.success',
}

export enum PlatformType {
  UNLIMITED = 'UNLIMITED',
  DOUYIN = 'DOUYIN',
  XIAOHONGSHU = 'XIAOHONGSHU',
  KUAISHOU = 'KUAISHOU',
  WEIBO = 'WEIBO',
  SHIPINHAO = 'SHIPINHAO',
  DIANPING = 'DIANPING',
  BILIBILI = 'BILIBILI',
  GUANGGUANG = 'GUANGGUANG',
  OTHER = 'OTHER',
}

export enum PlatformLevel {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  UNLIMITED = 0,
}

export const PlatformLevelText: Record<PlatformLevel, string> = {
  [PlatformLevel.ONE]: '1级',
  [PlatformLevel.TWO]: '2级',
  [PlatformLevel.THREE]: '3级',
  [PlatformLevel.FOUR]: '4级',
  [PlatformLevel.FIVE]: '5级',
  [PlatformLevel.SIX]: '6级',
  [PlatformLevel.SEVEN]: '7级',
  [PlatformLevel.EIGHT]: '8级',
  [PlatformLevel.UNLIMITED]: '不限',
};

export enum PriceSegmentLevel {
  PRICE_1 = 'p1',
  PRICE_2 = 'p2',
  PRICE_3 = 'p3',
  PRICE_4 = 'p4',
  PRICE_5 = 'p5',
  PRICE_6 = 'p6',
  PRICE_7 = 'p7',
  PRICE_UNLIMITED = 'p0',
  PRICE_REPLACE = 'p-1',
  PRICE_FEE = 'p-2',
  PRICE_SELF = 'p-3',
}

export const PriceSegmentLevelText: Record<PriceSegmentLevel, string> = {
  [PriceSegmentLevel.PRICE_UNLIMITED]: '不限',
  [PriceSegmentLevel.PRICE_REPLACE]: '置换',
  [PriceSegmentLevel.PRICE_FEE]: '有费',
  [PriceSegmentLevel.PRICE_SELF]: '自报价',
  [PriceSegmentLevel.PRICE_1]: '0-100',
  [PriceSegmentLevel.PRICE_2]: '100-300',
  [PriceSegmentLevel.PRICE_3]: '300-1000',
  [PriceSegmentLevel.PRICE_4]: '1000-5000',
  [PriceSegmentLevel.PRICE_5]: '5000-10000',
  [PriceSegmentLevel.PRICE_6]: '1w-5w',
  [PriceSegmentLevel.PRICE_7]: '5w以上',
};

export const PriceSegmentLevelValue: Record<PriceSegmentLevel, { minPrice: number; maxPrice: number }> = {
  [PriceSegmentLevel.PRICE_UNLIMITED]: null,
  [PriceSegmentLevel.PRICE_REPLACE]: null,
  [PriceSegmentLevel.PRICE_FEE]: null,
  [PriceSegmentLevel.PRICE_SELF]: null,
  [PriceSegmentLevel.PRICE_1]: { minPrice: 0, maxPrice: 100 },
  [PriceSegmentLevel.PRICE_2]: { minPrice: 100, maxPrice: 300 },
  [PriceSegmentLevel.PRICE_3]: { minPrice: 300, maxPrice: 1000 },
  [PriceSegmentLevel.PRICE_4]: { minPrice: 1000, maxPrice: 5000 },
  [PriceSegmentLevel.PRICE_5]: { minPrice: 5000, maxPrice: 10000 },
  [PriceSegmentLevel.PRICE_6]: { minPrice: 10000, maxPrice: 50000 },
  [PriceSegmentLevel.PRICE_7]: { minPrice: 50000, maxPrice: 1000000 },
};

export enum FanLevel {
  FAN_UNLIMITED = 'f0',
  FAN_1 = 'f1',
  FAN_2 = 'f2',
  FAN_3 = 'f3',
  FAN_4 = 'f4',
  FAN_5 = 'f5',
  FAN_6 = 'f6',
  FAN_7 = 'f7',
  FAN_8 = 'f8',
}

export const FanLevelText: Record<FanLevel, string> = {
  [FanLevel.FAN_UNLIMITED]: '不限',
  [FanLevel.FAN_1]: '0-1000粉',
  [FanLevel.FAN_2]: '1000-1w粉',
  [FanLevel.FAN_3]: '1w-3w粉',
  [FanLevel.FAN_4]: '3w-5w粉',
  [FanLevel.FAN_5]: '5w-10w粉',
  [FanLevel.FAN_6]: '10w-20w粉',
  [FanLevel.FAN_7]: '20w-50w粉',
  [FanLevel.FAN_8]: '50w粉以上',
};

export const FanLevelValue: Record<FanLevel, { minFan: number; maxFan: number }> = {
  [FanLevel.FAN_UNLIMITED]: null,
  [FanLevel.FAN_1]: { minFan: 0, maxFan: 1000 },
  [FanLevel.FAN_2]: { minFan: 1000, maxFan: 10000 },
  [FanLevel.FAN_3]: { minFan: 10000, maxFan: 30000 },
  [FanLevel.FAN_4]: { minFan: 30000, maxFan: 50000 },
  [FanLevel.FAN_5]: { minFan: 50000, maxFan: 100000 },
  [FanLevel.FAN_6]: { minFan: 100000, maxFan: 200000 },
  [FanLevel.FAN_7]: { minFan: 200000, maxFan: 500000 },
  [FanLevel.FAN_8]: { minFan: 500000, maxFan: 999999999 },
};

/// 购买类型
export enum PurchaseType {
  MEMBER = 'member',
  DISTRIBUTOR = 'distributor',
}

// 协议类型枚举
export enum ProtocolType {
  USER_AGREEMENT = 'user_agreement',
  PRIVACY_POLICY = 'privacy_policy',
  WITHDRAW_PROTOCOL = 'withdraw_protocol',
  MEMBERSHIP_SERVICE_AGREEMENT = 'membership-service-agreement',
  RECOMMENDER_SERVICE_AGREEMENT = 'recommender-service-agreement',
}

// URL映射配置
export const ProtocolTypeURLMap = {
  [ProtocolType.USER_AGREEMENT]: 'portal/platform-agreement/user-agreement.html',
  [ProtocolType.PRIVACY_POLICY]: 'portal/platform-agreement/privacy-of-user.html',
  [ProtocolType.WITHDRAW_PROTOCOL]: 'portal/platform-agreement/sharing-economy-partnership-agreement.html',
  [ProtocolType.MEMBERSHIP_SERVICE_AGREEMENT]: 'portal/platform-agreement/membership-service-agreement.html',
  [ProtocolType.RECOMMENDER_SERVICE_AGREEMENT]: 'portal/platform-agreement/recommender-service-agreement.html',
};

// 标题映射配置
export const ProtocolTypeTitleMap = {
  [ProtocolType.USER_AGREEMENT]: '用户协议',
  [ProtocolType.PRIVACY_POLICY]: '隐私政策',
  [ProtocolType.WITHDRAW_PROTOCOL]: '共享经济合作伙伴协议',
  [ProtocolType.MEMBERSHIP_SERVICE_AGREEMENT]: '探鲸平台会员服务协议',
  [ProtocolType.RECOMMENDER_SERVICE_AGREEMENT]: '探鲸平台推荐官服务协议',
};

// 分享场景类型
export enum ShareSceneType {
  // 分享通告详情
  NOTICE_DETAIL = 'notice-detail',
  // 分享探鲸小程序
  SHARE_TUNGEA_MINI_APP = 'share-tungea-mini-app',
  // 推荐官分享页面分享场景（给想赚钱的-跳成为推荐官页）
  RECOMMENDER_SHARE = 'recommender-share',
  // 推荐官分享-给达人（跳通告广场首页）
  RECOMMENDER_NOTICE_SQUARE = 'recommender-notice-square',
  // 推荐官分享-给PR（跳发通告页）
  RECOMMENDER_PUBLISH = 'recommender-publish',
}
